'use strict';
var parent = require('../../es/symbol/to-string-tag');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/symbol/to-string-tag.js
// module id = 785
// module chunks = 13